import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, nextTick, watch } from "vue";
import { Layer } from "mapbox-gl";
import { inputSelect } from "@components/input";
import SingleStyle from "./single-style.vue";
import { LayerSimpleMapboxBuild } from "@/model";
import { mdiClose, mdiDelete, mdiPlus } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import { useShow } from "@/hooks/useShow";
import baseButton from "@/components/base/base-button.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'multi-style',
  props: {
  value: {
    required: true
  },
  trans: {
    required: true
  },
  mapId: {
    required: true
  }
},
  emits: ["input", "update-style", "close"],
  setup(__props, { emit }) {

const props = __props



const layers = computed<Layer[]>({
  get() {
    return props.value as Layer[];
  },
  set(value) {
    emit("input", value);
  }
});
watch(layers, () => {
  if (!tab.value && layers.value.length > 0) {
    tab.value = layers.value[layers.value.length - 1].id;
  }
});
const onSelectTab = (layer_id: string) => {
  tab.value = undefined;
  nextTick(() => {
    tab.value = layer_id;
  });
};
const onUpdateStyleLayer = (layer: Layer, layer_id: string) => {
  emit("update-style", {
    type: "update-one-layer",
    layer,
    index: layers.value.findIndex((x) => x.id === layer_id)
  });
};
const onAddStyleLayer = (type: string) => {
  tab.value = undefined;
  emit("update-style", {
    type: "add-one-layer",
    layer: new LayerSimpleMapboxBuild()
      .setStyleType(type)
      .setColor("#fff")
      .build()
  });
  onShowAddStyle(false);
};
const onRemoveStyleLayer = (layer_id: string) => {
  let index = layers.value.findIndex((x) => x.id === layer_id);
  if (!layers.value[index]) {
    return;
  }
  tab.value = undefined;
  emit("update-style", {
    type: "remove-one-layer",
    index,
    layer: layers.value[index]
  });
  layers.value.splice(index, 1);
  if (layers.value[0]) onSelectTab(layers.value[0].id);
};
const tab = ref<string | undefined>(layers.value[0].id);
const tabs = computed(() => {
  return layers.value.map((x, i) => {
    return { text: `#${i + 1}`, value: x.id };
  });
});
const current_layer = computed(() => {
  return layers.value.find((x) => x.id === tab.value);
});
const path = {
  delete: mdiDelete,
  create: mdiPlus,
  close: mdiClose
};
const [showAdd, setShowAdd] = useShow(false);
const onShowAddStyle = (value: boolean) => {
  setShowAdd(value);
};

return { __sfc: true,props, emit, layers, onSelectTab, onUpdateStyleLayer, onAddStyleLayer, onRemoveStyleLayer, tab, tabs, current_layer, path, showAdd, setShowAdd, onShowAddStyle, inputSelect, SingleStyle, SvgIcon, baseButton }
}

})